import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericService } from '../../generic.service';
import { Router, RouterModule } from '@angular/router';
import { PopUpComponent } from '../pop-up/pop-up.component';
import { HeaderComponent } from '../../shared/header/header.component';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { LandingService } from '../../landing-page/service/landing.service';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-poor-results-elt',
    imports: [CommonModule, RouterModule, PopUpComponent, HeaderComponent],
    templateUrl: './poor-results-elt.component.html',
    styleUrl: './poor-results-elt.component.scss'
})
export class PoorResultsEltComponent {
  deviceData: any = {};
  deviceData$: any = null;

  issueName: string | undefined;
  qrId: any;
  accountNumber: string = '';
  showImagePopup: boolean = false;
  popupImages: string[] = [];
  currentItem: any = null;
  showPopup: boolean = false;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  issueListElt = [
    {
      titleKey: 'poorResults.elt.title.sanitizerIssue',
      detailsKey: 'poorResults.elt.details.sanitizerIssue',
      answered: false,
      status: '',
      expanded: false,
      images: [],
      video: '',
    },
    {
      titleKey: 'poorResults.elt.title.waterOn',
      detailsKey: '',
      answered: false,
      status: '',
      expanded: false,
      images: [],
      video: '',
    },
    {
      titleKey: 'poorResults.elt.title.endCap',
      detailsKey: 'poorResults.elt.details.endCap',
      answered: false,
      status: '',
      expanded: false,
      images: ['assets/images/troubleshooting/eht/eht-spray-end-cap.gif'],
      video: '',
    },
    {
      titleKey: 'poorResults.elt.title.armSpinFreeze',
      detailsKey: 'poorResults.elt.details.armSpinFreeze',
      answered: false,
      status: '',
      expanded: false,
      images: ['assets/images/troubleshooting/eht/eht-spray-arm-spins.gif'],
      video: '',
    },
    {
      titleKey: 'poorResults.elt.title.noDebrisArm',
      detailsKey: 'poorResults.elt.details.noDebrisArm',
      answered: false,
      status: '',
      expanded: false,
      images: [
        'assets/images/troubleshooting/eht/eht-spray-nozzle-1.png',
        'assets/images/troubleshooting/eht/eht-spray-nozzle-2.gif',
      ],
      video: '',
    },
    {
      titleKey: 'poorResults.elt.title.primeChemist',
      detailsKey: '',
      answered: false,
      status: '',
      expanded: false,
      images: [],
      video: '',
    },
    {
      keyValue: 1,
      titleKey: 'poorResults.elt.title.noLimeScale',
      detailsKey: 'poorResults.elt.details.noLimeScale',
      answered: false,
      status: '',
      expanded: false,
      images: [
        'assets/images/poorresults/lime-scale.png',
        'assets/images/poorresults/lime-scale-dirt.png',
      ],
      video: '',
    },
    {
      titleKey: 'poorResults.elt.title.softener',
      detailsKey: 'poorResults.elt.details.softener',
      answered: false,
      status: '',
      expanded: false,
      images: [],
      video: '',
    },
  ];

  constructor(
    private router: Router,
    private genericService: GenericService,
    private crowdinService: CrowdinService,
    private landingService: LandingService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();
    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  get progress() {
    const answered = this.issueListElt.filter((item) => item.answered).length;
    return (answered / this.issueListElt.length) * 100;
  }

  answer(index: number, status: string) {
    this.issueListElt[index].status = status;
    this.issueListElt[index].answered = true;
    if (this.issueListElt[index].detailsKey) {
      this.issueListElt[index].expanded = true;
    }
  }

  toggleAccordion(index: number) {
    this.issueListElt[index].expanded = !this.issueListElt[index].expanded;
  }

  resolved() {
    this.router.navigateByUrl('thankYou');
  }

  needHelp() {
    this.landingService.needHelp();
  }

  requestHelp(option: any) {
    this.deviceData['issueName'] = this.issueName;
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.router.navigate(['/esrSupport']);
  }

  getTranslatedTitle(item: any): string {
    return this.translations?.[item.titleKey] ?? item.titleKey;
  }

  getTranslatedDetails(item: any): string {
    return this.translations?.[item.detailsKey] ?? item.detailsKey;
  }

  openPopup(images: string[], title?: string) {
    this.popupImages = images;
    this.showPopup = true;
  }

  openImagePopup(images: string[], item: any) {
    this.popupImages = images;
    this.showImagePopup = true;
  }

  closePopup() {
    this.showPopup = false;
    this.showImagePopup = false;
  }
}
